import { PageType } from '@blk/simba';

import { SvgImage } from '../static-section/svg-image';

export const CLIENT_PORTRAIT_HEADER = `
<g id="Master-header">
	<text id="Portfolio-Solutions" font-family="FortBook" font-size="8" font-weight="300" fill="#616161">
		<tspan x="1" y="5">PORTFOLIO SUMMARY</tspan>
	</text>
	<path d="M0.5,10.5 L${PageType.LetterPortrait.contentWidth}.5,10.5" id="Line" stroke="#616161" stroke-width="0.25" stroke-linecap="square" fill-rule="nonzero"></path>
</g>`;

export const CLIENT_LANDSCAPE_HEADER = `
<g id="Master-header">
	<text id="Portfolio-Solutions" font-family="FortBook" font-size="8" font-weight="300" fill="#616161">
		<tspan x="1" y="5">PORTFOLIO SUMMARY</tspan>
	</text>
	<path d="M0.5,10.5 L${PageType.LetterPortrait.contentWidth}.5,10.5" id="Line" stroke="#616161" stroke-width="0.25" stroke-linecap="square" fill-rule="nonzero"></path>
</g>`;

export const ADVISOR_PORTRAIT_PC_HEADER = `
<g id="Master-header">
	<text id="Portfolio-Solutions" font-family="FortBook" font-size="10" font-weight="300">
		<tspan x="1" y="5">PORTFOLIO SUMMARY</tspan>
	</text>
	<text id="Portfolio-Solutions" font-family="FortBook" font-size="10" font-weight="300">
		<tspan x="247" y="5">FOR PROFESSIONAL CLIENTS/QUALIFIED INVESTORS ONLY</tspan>
	</text>
	<path d="M0.5,10.5 L${PageType.LetterPortrait.contentWidth}.5,10.5" id="Line" stroke="#616161" stroke-width="0.25" stroke-linecap="square" fill-rule="nonzero"></path>
</g>`;

export const CLIENT_PORTRAIT_PC_HEADER = `
<g id="Master-header">
	<text id="Portfolio-Solutions" font-family="FortBook" font-size="10" font-weight="300">
		<tspan x="1" y="5">PORTFOLIO SUMMARY</tspan>
	</text>
	<path d="M0.5,10.5 L${PageType.LetterPortrait.contentWidth}.5,10.5" id="Line" stroke="#616161" stroke-width="0.25" stroke-linecap="square" fill-rule="nonzero"></path>
</g>`;

const IRETIRE_PORTRAIT_HEADER_BASE = (height = 5) => `<g id="Master-header">
<text id="Iretire" font-family="FortBook" font-size="8" font-weight="300" fill="#616161">
	<tspan x="1" y="${height}">iRETIRE</tspan>
</text>
<path d="M0.5,${height + 5}.5 L${PageType.LetterPortrait.contentWidth}.5,${height + 5}.5" id="Line" stroke="#616161" stroke-width="0.25" stroke-linecap="square" fill-rule="nonzero"></path>
`;

export const IRETIRE_PORTRAIT_HEADER = `
	${IRETIRE_PORTRAIT_HEADER_BASE()}
</g>`;

export const IRETIRE_PNCI_PORTRAIT_HEADER = `
	${IRETIRE_PORTRAIT_HEADER_BASE(30)}
	${new SvgImage('IRETIRE_PNCI_LOGO_OTHER').getStaticContent()}
	${new SvgImage('IRETIRE_PNCI_BARCODE_OTHER').getStaticContent()}
</g>
`;

export const CLIENT_PORTRAIT_PAC_HEADER = `
<g id="Master-header">
	<text id="Portfolio-Solutions" font-family="FortBook" font-size="10" font-weight="300">
		<tspan x="1" y="5">PORTFOLIO SUMMARY</tspan>
	</text>
	<text id="Portfolio-Solutions" font-family="FortBook" font-size="10" font-weight="300">
		<tspan text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="5">$audience$</tspan>
	</text>
	<path d="M0.5,10.5 L${PageType.LetterPortrait.contentWidth}.5,10.5" id="Line" stroke="#616161" stroke-width="0.25" stroke-linecap="square" fill-rule="nonzero"></path>
</g>`;

// Don't change text-anchor:end tspans formatting, cannot leave whitespace between them for batik compatibility
export const CLIENT_PORTRAIT_FOOTER = `
<g id="Report_ClientFooter" fill="#616161" font-family="FortBook" font-size="8">
	<text id="REPORT-GENERATED-ON">
		<tspan text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="5">REPORT GENERATED ON</tspan><tspan
			   text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="14">$date$</tspan><tspan
			   text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="23">PAGE $pageNo$ of $pageTotal$</tspan>
	</text>
	<text>
		<tspan x="0" y="5">
			<tspan>$advisorName$</tspan>
		</tspan>
		<tspan x="0" y="14">
			<tspan font-family="FortBold" font-weight="bold">PREPARED BY: </tspan>
			<tspan>$clientName$</tspan>
		</tspan>
		<tspan x="0" y="23">
			<tspan font-family="FortBold" font-weight="bold">FIRM NAME: </tspan>
			<tspan>$firm$</tspan>
		</tspan>

	</text>
</g>`;

export const CLIENT_LANDSCAPE_FOOTER = `
<g id="Report_ClientFooter" fill="#616161" font-family="FortBook" font-size="8">
	<text id="REPORT-GENERATED-ON">
		<tspan text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="5">REPORT GENERATED ON</tspan><tspan
			   text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="14">$date$</tspan><tspan
			   text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="23">PAGE $pageNo$ of $pageTotal$</tspan>
	</text>
	<text>
		<tspan x="0" y="5">
			<tspan>$advisorName$</tspan>
		</tspan>
		<tspan x="0" y="14">
			<tspan font-family="FortBold" font-weight="bold">PREPARED BY: </tspan>
			<tspan>$clientName$</tspan>
		</tspan>
		<tspan x="0" y="23">
			<tspan font-family="FortBold" font-weight="bold">FIRM NAME: </tspan>
			<tspan>$firm$</tspan>
		</tspan>

	</text>
</g>`;

// Don't change text-anchor:end tspans formatting, cannot leave whitespace between them for batik compatibility
export const PC_ADVISOR_PORTRAIT_FOOTER = `
<g id="Report_AdvisorFooter" fill="#616161" font-family="FortBook" font-size="8">
	<text id="REPORT-GENERATED-ON">
		<tspan text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="5">REPORT GENERATED ON</tspan><tspan
			   text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="14">$date$</tspan><tspan
			   text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="23">PAGE $pageNo$ of $pageTotal$</tspan>
	</text>
	<text>
		<tspan x="0" y="14">
			<tspan>$clientName$</tspan>
		</tspan>
	</text>
</g>`;

export const PC_CLIENT_PORTRAIT_FOOTER = `
<g id="Report_ClientFooter" fill="#616161" font-family="FortBook" font-size="8">
    <text id="REFER_GLOSSARY_SECTION" font-family="FortBook" font-size="10" font-weight="300">
		<tspan x="0" y="-4">Please refer to the “Glossary” section in this report for additional information.</tspan>
	</text>
	<text id="REPORT-GENERATED-ON">
		<tspan text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="5">REPORT GENERATED ON</tspan><tspan
			   text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="14">$date$</tspan><tspan
			   text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="23">PAGE $pageNo$ of $pageTotal$</tspan>
	</text>
	<text>
		<tspan x="0" y="14">
			<tspan>$clientName$</tspan>
		</tspan>
	</text>
</g>`;

// Don't change text-anchor:end tspans formatting, cannot leave whitespace between them for batik compatibility
export const PAC_CLIENT_PORTRAIT_FOOTER = `
<g id="Report_ClientFooter" fill="#616161" font-family="FortBook" font-size="8">
	<text id="REPORT-GENERATED-ON">
		<tspan text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="5">REPORT GENERATED ON $date$</tspan>
	</text>
	<text>
		<tspan x="0" y="5">
			<tspan>PREPARED FOR: $clientName$</tspan>
		</tspan>
	</text>
</g>`;

export const LANDSCAPE_FOOTER = `
<g id="Report_ClientFooter" fill="#616161" font-family="FortBook" font-size="8">
	<text id="REPORT-GENERATED-ON">
		<tspan text-anchor="end" x="${PageType.LetterLandscape.contentWidth}" y="5">REPORT GENERATED ON</tspan><tspan
			   text-anchor="end" x="${PageType.LetterLandscape.contentWidth}" y="14">$date$</tspan><tspan
			   text-anchor="end" x="${PageType.LetterLandscape.contentWidth}" y="23">PAGE $pageNo$ of $pageTotal$</tspan>
	</text>
	$DCR_LANDSCAPE_FOOTER_TEXT$
</g>`;

export const LANDSCAPE_HEADER = (headerTitle) => `
<g id="Master-header">
	<text id="Portfolio-Solutions" font-family="FortBook" font-size="8" font-weight="300" fill="#616161">
		<tspan x="1" y="5">${headerTitle}</tspan>
	</text>
	<path d="M0.5,10.5 L${PageType.LetterLandscape.contentWidth}.5,10.5" id="Line" stroke="#616161" stroke-width="0.25" stroke-linecap="square" fill-rule="nonzero"></path>
</g>`;


export const IRETIRE_PORTRAIT_FOOTER = `
<g id="IRETIRE_Report_ClientFooter" fill="#616161" font-family="FortBook" font-size="8">
	<text id="REPORT-GENERATED-ON">
		<tspan text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="14">REPORT GENERATED ON $date$</tspan><tspan
			   text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="23"><tspan font-family="FortBold" font-weight="bold">iRETIRE</tspan> BY BLACKROCK</tspan><tspan
			   text-anchor="end" x="${PageType.LetterPortrait.contentWidth}" y="32">PAGE $pageNo$ of $pageTotal$</tspan>
	</text>
	<text>
		<tspan x="0" y="5">
			<tspan>$advisorName$</tspan>
		</tspan>
		<tspan x="0" y="14">
			<tspan font-family="FortBold" font-weight="bold">PREPARED BY: </tspan>
			<tspan>$clientName$</tspan>
		</tspan>
		<tspan x="0" y="23">
			<tspan font-family="FortBold" font-weight="bold">FIRM NAME: </tspan>
			<tspan>$firm$</tspan>
		</tspan>
	</text>
</g>`;

